import { titleize } from 'inflected';
import { MetadataEnumSeverity, MetadataEnumTypeData } from '../metadata/entity/decorators/model/metadata.entity.field.data';
import { InvoiceStatus } from '../entities/invoicing/invoicing.enum';
import { InvoiceType } from '../entities/invoicing/invoicing';

// Colors are WB design-token CSS variables so they resolve theme-aware on the web; semantics mirror
// the invoice document preview (invoice.tag.style.ts): Approved → brand, Error → red, Draft/Void → gray.
const STATUS_ORDER: InvoiceStatus[] = [InvoiceStatus.Draft, InvoiceStatus.Approved, InvoiceStatus.Void, InvoiceStatus.Error];

const STATUS_COLOR: Record<InvoiceStatus, string> = {
    [InvoiceStatus.Draft]: 'var(--wb-component-colors-utility-gray-400)',
    [InvoiceStatus.Approved]: 'var(--wb-component-colors-utility-brand-500)',
    [InvoiceStatus.Void]: 'var(--wb-component-colors-utility-gray-400)',
    [InvoiceStatus.Error]: 'var(--wb-component-colors-utility-error-500)',
};

export function getInvoiceStatusEnumMetadata(): MetadataEnumTypeData[] {

    return STATUS_ORDER.map(status => ({
        key: status,
        value: status,
        color: STATUS_COLOR[status],
    }));
}

// Type badges carry a semantic severity, resolved to the DS badge palette on the web: credit notes →
// warning, prepayments → special, all other (standard) invoice/bill types fall back to neutral.
const TYPE_SEVERITY: Partial<Record<InvoiceType, MetadataEnumSeverity>> = {
    [InvoiceType.CreditNote]: 'warning',
    [InvoiceType.CreditNoteSupplier]: 'warning',
    [InvoiceType.PrepaymentInvoice]: 'special',
    [InvoiceType.PrepaymentSupplier]: 'special',
};

/** Enum metadata for InvoiceType-valued enums (InvoiceType itself or the Filterable* subsets). */
export function getInvoiceTypeEnumMetadata(item: any): MetadataEnumTypeData[] {

    return Object
        .keys(item)
        .sort((a, b) => titleize(a).localeCompare(titleize(b)))
        .map(key => ({
            key: titleize(key),
            value: item[key],
            severity: TYPE_SEVERITY[item[key] as InvoiceType] ?? 'neutral',
        }));
}
